import React from 'react';
import { ListGroup as CoreListGroup } from '@vds-core/lists';

var ListGroup = function ListGroup(props) {
  return /*#__PURE__*/React.createElement(CoreListGroup, props);
};

export default ListGroup;